<template>
  <v-container class="pa-0 white--text headline" fluid>
    <!-- The image of the item -->
    <v-layout justify-center>
      <v-flex shrink>
        <v-img contain :height="imageHeight" :width="imageWidth" :src="item.image" />
      </v-flex>
    </v-layout>
    <!-- The brand of the item -->
    <v-layout>
      <v-flex class="px-5 pt-3">{{ item.brand }}</v-flex>
    </v-layout>
    <!-- The name of the item -->
    <v-layout class="font-weight-light">
      <v-flex class="px-5">{{ item.name }}</v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
      validator: val => !!val.image && !!val.brand && !!val.name
    }
  },
  computed: {
    imageHeight() {
      return window.innerHeight * 0.5;
    },
    imageWidth() {
      return window.innerWidth * 0.4;
    }
  }
};
</script>